import { Link } from 'react-router-dom';

const collections = [
  { label: 'Antiques & Vintage', href: '/collections/antiques' },
  { label: 'Furniture', href: '/collections/furniture' },
  { label: 'Gifts & Home Décor', href: '/collections/gifts' },
  { label: 'Boutique Apparel', href: '/collections/apparel' },
];

export default function Footer() {
  return (
    <footer className="bg-inkblack font-sans">
      {/* Pre-footer strip */}
      <div className="border-b border-white/10 px-8 lg:px-12 py-10">
        <div className="max-w-screen-xl mx-auto flex flex-col lg:flex-row items-center justify-between gap-6">
          <div className="flex flex-col lg:flex-row items-center gap-6 lg:gap-12">
            <div className="flex items-center gap-3 text-white/60 text-xs font-sans tracking-widest uppercase">
              <i className="ri-time-line text-antique" />
              Open Daily: 9:00 AM – 5:00 PM
            </div>
            <div className="flex items-center gap-3 text-white/60 text-xs font-sans tracking-widest uppercase">
              <i className="ri-map-pin-line text-antique" />
              22899 S Hwy 89, Yarnell, AZ 85362
            </div>
            <a href="tel:9284279593" className="flex items-center gap-3 text-white/60 hover:text-antique text-xs font-sans tracking-widest uppercase transition-colors cursor-pointer">
              <i className="ri-phone-line text-antique" />
              928.427-9593
            </a>
          </div>
          <a
            href="https://maps.google.com/?q=22899+S+Hwy+89+Yarnell+AZ+85362"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-antique text-inkblack text-xs font-600 tracking-[0.12em] uppercase px-8 py-3 whitespace-nowrap hover:bg-white transition-colors cursor-pointer"
          >
            Get Directions
          </a>
        </div>
      </div>

      {/* Main footer */}
      <div className="px-8 lg:px-12 py-16">
        <div className="max-w-screen-xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="mb-6">
              <span className="font-serif text-white text-2xl font-600 tracking-wide block leading-tight">Yarnell</span>
              <span className="font-serif text-antique text-sm font-400 tracking-[0.25em] uppercase block">Emporium</span>
            </div>
            <p className="text-xs text-white/40 leading-relaxed mb-6 max-w-xs">
              A boutique destination for antiques, unique furniture, gifts, and apparel in the heart of Yarnell, AZ. Curated finds that tell a story.
            </p>
            <div className="flex items-center gap-3">
              <a
                href="mailto:ed@yarnellemporium.com"
                className="w-9 h-9 flex items-center justify-center border border-white/15 text-white/40 hover:text-antique hover:border-antique transition-colors cursor-pointer"
                aria-label="Email"
              >
                <i className="ri-mail-line text-sm" />
              </a>
              <a
                href="tel:9284279593"
                className="w-9 h-9 flex items-center justify-center border border-white/15 text-white/40 hover:text-antique hover:border-antique transition-colors cursor-pointer"
                aria-label="Phone"
              >
                <i className="ri-phone-line text-sm" />
              </a>
            </div>
          </div>

          {/* Collections */}
          <div>
            <h4 className="text-xs uppercase tracking-[0.18em] text-white/30 mb-6 font-500">Collections</h4>
            <ul className="flex flex-col gap-3">
              {collections.map((c) => (
                <li key={c.href}>
                  <Link to={c.href} className="text-xs text-white/50 hover:text-antique transition-colors cursor-pointer tracking-wide">
                    {c.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Navigate */}
          <div>
            <h4 className="text-xs uppercase tracking-[0.18em] text-white/30 mb-6 font-500">Navigate</h4>
            <ul className="flex flex-col gap-3">
              {[
                { label: 'Home', href: '/' },
                { label: 'About Us', href: '/about' },
                { label: 'Location', href: '/location' },
              ].map((p) => (
                <li key={p.href}>
                  <Link to={p.href} className="text-xs text-white/50 hover:text-antique transition-colors cursor-pointer tracking-wide">
                    {p.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Visit */}
          <div>
            <h4 className="text-xs uppercase tracking-[0.18em] text-white/30 mb-6 font-500">Visit Us</h4>
            <ul className="flex flex-col gap-4">
              <li>
                <p className="text-xs text-white/30 tracking-wide uppercase mb-1">Address</p>
                <p className="text-xs text-white/60">22899 S Hwy 89<br />Yarnell, AZ 85362</p>
              </li>
              <li>
                <p className="text-xs text-white/30 tracking-wide uppercase mb-1">Hours</p>
                <p className="text-xs text-white/60">Open Every Day<br />9:00 AM – 5:00 PM</p>
              </li>
              <li>
                <p className="text-xs text-white/30 tracking-wide uppercase mb-1">Contact</p>
                <a href="tel:9284279593" className="text-xs text-white/60 hover:text-antique transition-colors cursor-pointer block">928.427-9593</a>
                <a href="mailto:ed@yarnellemporium.com" className="text-xs text-white/60 hover:text-antique transition-colors cursor-pointer block">ed@yarnellemporium.com</a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/8 px-8 lg:px-12 py-5">
        <div className="max-w-screen-xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-white/20">&copy; {new Date().getFullYear()} Yarnell Emporium. All rights reserved.</p>
          <p className="text-xs text-white/20">Antiques · Furniture · Gifts · Apparel — Yarnell, AZ</p>
        </div>
      </div>
    </footer>
  );
}